import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import LinkInI18nBlock from 'src/enosikit/components/LinkInI18nBlock';
import { isIntercomEnabled, showIntercom } from 'src/util/intercom';

/**
 * Support call to action rendered inside an i18n block. Opens the Intercom
 * messenger on deployments configured to use it, otherwise links to the
 * deployment's own support url. The url is optional: a partner who blanks out
 * the override is choosing not to offer a support destination, so the call to
 * action renders as unlinked text rather than being redirected to Enosi's own
 * support site.
 * @param {object} props
 * @param {React.ReactNode} props.chunks - chunks to be rendered as the link text.
 * @returns {React.ReactComponentElement} - SupportLink component
 */
function SupportLink({ chunks }) {
  const intl = useIntl();

  if (isIntercomEnabled()) {
    return (
      <button
        className="btn btn-link d-inline p-0 align-baseline text-primary"
        onClick={showIntercom}
        type="button"
      >
        {chunks}
      </button>
    );
  }

  const configuredUrl = intl.formatMessage({
    id: 'dashboard.support_link.url',
    defaultMessage: 'https://support.enosi.energy/',
  }).trim();

  return (
    <LinkInI18nBlock
      chunks={chunks}
      url={configuredUrl}
      urlKey="dashboard.support_link.url"
    />
  );
}

SupportLink.propTypes = {
  chunks: PropTypes.node.isRequired,
};

export default SupportLink;
